import _ from "lodash";
import { getUserCoursesV2Query } from "./CoursePaginationQuery";
import client from "lib/apolloClient/client";
import { singleCourseV2Fragment } from "./CoursesFragments";

export const getUserCoursesV2FromCache = ({
  userId,
  first,
  orderBy,
  orderByDirection,
  courseFilters,
  courseGradeFilters,
  archivedCourseFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getUserCoursesV2Query,
      variables: {
        userId,
        first,
        courseFilters,
        courseGradeFilters,
        archivedCourseFilters,
      },
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getSingleCourseV2FromCache = ({
  courseId,
  courseGradeFilters,
}) => {
  let singleCourse = {};
  try {
    singleCourse = client.readFragment({
      id: `Course:${courseId}`,
      fragment: singleCourseV2Fragment,
      fragmentName: "singleCourseV2",
      variables: { courseGradeFilters },
    });
    return singleCourse;
  } catch (e) {
    return {};
  }
};

export const writeSingleCourseV2IntoCache = ({
  courseId,
  courseGradeFilters,
  data,
}) => {
  try {
    client.writeFragment({
      id: `Course:${courseId}`,
      fragment: singleCourseV2Fragment,
      fragmentName: "singleCourseV2",
      data: data,
      variables: { courseGradeFilters },
    });
  } catch (e) {
    console.error(e);
  }
};
